// Retrieve the authUser object from localStorage
const getAccessToken = () => {
  const authUserString = localStorage.getItem("authUser");
  let token = null,
    orgCode = null,
    orgSecretKey = null; // Initialize token variable

  if (authUserString) {
    const authUser = JSON.parse(authUserString);

    // Check if the authUser object contains the token property
    if (authUser.token) {
      // Access the token property from the authUser object
      token = authUser.token; // Assign token value
      orgCode = authUser?.organizationManager?.code; // Assign token value
      orgSecretKey = authUser?.organizationManager?.secretKey; // Assign token value
    } else {
      console.error("Token not found in authUser object");
    }
  } else {
    console.error("AuthUser data not found in localStorage");
  }

  return { token, orgSecretKey, orgCode };
};

export default getAccessToken;
